export const reallyClipboardCopyLocalName = 'really-clipboard-copy' as const;
